// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import Mark from 'mark.js';

export const ContentFilter = (el) => {
  const ui = {
    el,
    textFilter: select('#js-text-filter', el),
    categoryFilter: select('#js-category-name', el),
    context: select('.columnized-links__list', el),
    clearBtn: select('[type="reset"]', el),
    count: select('.content-filter__count', el),
    childrenContainer: select('.content-filter__children', el),
    notFoundHeading: select('#js-term-not-found', el),
    notFoundMark: select ('#js-term-not-found mark'),
  };

  var instance = new Mark(ui.context);
  var options = {
    'exclude': ['.link:not(.include)'],
    'ignorePunctuation': [
        "`",
        "'",
        "ʻ",
        "’", // respect the okina
    ],
    'debug': false,
    'separateWordSearch': true,
    'done': function() {
      setCounter();
    }
  }

  const contextItem = '.link';
  const allLinks = select.all(contextItem, ui.context);

  const addIncludeClass = () => {
    allLinks.forEach(link => {
      link.classList.add('include');
    });
  }

  const addTitleAttributes = () =>{
    allLinks.forEach(link => {
      let hiddenText = select('[hidden]', link);
      if (hiddenText) {
        link.setAttribute('title', hiddenText.textContent);
      }
    });
  }

  const setCounter = () => {
    let count = 0;

    allLinks.forEach(link => {
      if (link.getClientRects().length) { count = count + 1; }
    });

    if (count > 0) {
      ui.notFoundHeading.classList.remove('active');
      ui.count.innerHTML = '<strong class="sr-only">' + count + '&nbsp; Results found</strong>';
    } else {
      ui.notFoundHeading.classList.add('active');
      ui.notFoundMark.innerHTML = ui.textFilter.value;
    }
  }

  const clearMarks = () => {
    addIncludeClass();
    ui.context.removeAttribute('data-filtered-by-text');
    instance.unmark();
    setCounter();
  };

  const addMarks = (term) => {
    if (term) {
      instance.unmark();
      instance.mark(term, options);
      ui.context.setAttribute('data-filtered-by-text', 'true');
    } else {
      ui.context.removeAttribute('data-filtered-by-text');
      clearMarks();
    }
    setCounter();
  }

  const resetLinks = () => {
    allLinks.forEach(link => {
      link.classList.remove('category', 'include');
    });
  }

  const resetInstance = () => {
    clearMarks();

    allLinks.forEach(link => {
      link.classList.remove('category');
    });

    ui.context.removeAttribute('data-filtered-by-text');
    ui.context.removeAttribute('data-filtered-by-category');

    setCounter();
  }

  // massage the search text (future functionality)
  const createSearchtext = (term) => {
    addMarks(term);
  }

  const handleCategory = () => {
    let currentcategory = ui.categoryFilter.value;
    let currentText = ui.textFilter.value;

    if (currentcategory) {
      resetLinks();

      let categoryLinks = select.all(`.link.${currentcategory}`);
      categoryLinks.forEach(link => {
        link.classList.add('category', 'include');
      });

      ui.context.setAttribute('data-filtered-by-category', 'true');

    } else {
      if (currentText) {
        instance.mark(currentText);
      } else {
        allLinks.forEach(link => {
          link.classList.remove('category');
        });

        addIncludeClass();
        ui.context.removeAttribute('data-filtered-by-category');
      }
    }
  }

  const addEvents = () => {
    if (ui.clearBtn) {
      ui.clearBtn.addEventListener('click', () => {
        resetInstance();
      });
    }

    if (ui.textFilter) {
      ui.textFilter.addEventListener('keyup', () => {
        setTimeout(function() {
          createSearchtext(ui.textFilter.value);
        }, 200);
      });
    }

    if (ui.categoryFilter) {
      ui.categoryFilter.addEventListener('change', () =>  {
        handleCategory();
        setCounter();
      });
    }
  }

  const init = () => {
    addIncludeClass();
    addTitleAttributes();
    addEvents();
  };

  init();
};

export default ContentFilter;
